import React, { useRef } from "react"
import styled from "styled-components"
import {
	Container,
	SubTitle,
	Paragrph,
	VideoContainer,
	VideoURL,
	Overlay,
	Button,
	BlackOverlay,
} from "./Video.styles"

export const Video = ({ data }) => {
	const subTitle = data.primary.subtitle[0]?.text
	const paragraph = data.primary.paragraph[0]?.text
	const videoLink = data.primary.video_link.url
	const overlay = data.primary.video_overlay[0]?.text
	const thumbnail = data.primary.video_thumbnail?.url

	const vidRef = useRef(null)
	const [showResults, setShowResults] = React.useState(true)
	const handlePlayVideo = () => {
		vidRef.current.play()
		setShowResults(false)
	}
	const handlePauseVideo = () => {
		vidRef.current.pause()
		setShowResults(true)
	}

	var isEmbed = false
	if (videoLink.includes("youtube") || videoLink.includes("vimeo")) {
		isEmbed = true
	}
	if (isEmbed) {
		return (
			<>
				<Container>
					<iframe
						src={videoLink}
						title="Video player"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowfullscreen
					></iframe>
				</Container>
			</>
		)
	} else {
		return (
			<>
				<Container>
					<SubTitle>{subTitle}</SubTitle>
					<Paragrph>{paragraph}</Paragrph>
					{showResults ? (
						<VideoContainer onClick={handlePlayVideo}>
							<VideoURL
								ref={vidRef}
								src={videoLink}
								poster={thumbnail}
								playsInline
							></VideoURL>
							<BlackOverlay></BlackOverlay>
							<Overlay>{overlay}</Overlay>
							<Button onClick={handlePlayVideo}>WATCH VIDEO</Button>
						</VideoContainer>
					) : (
						<VideoContainer onClick={handlePauseVideo}>
							<VideoURL
								ref={vidRef}
								src={videoLink}
								poster={thumbnail}
								playsinline
							></VideoURL>
						</VideoContainer>
					)}
				</Container>
			</>
		)
	}
}
